import React,{ useCallback, useEffect, useState } from "react";
import { Divider } from "antd";
import AdjustmentHeader from "./AdjustmentHeader";
import LoadingBox from "../../shared/LoadingBox";
import AlertBox from "../../shared/AlertBox";
import AdjustmentRow from "./AdjustmentRow";
import AdjustmentFooter from "./AdjustmentFooter";
import { voidAdjustment } from "./AdjustmentService";


export function AdjustmentInfo({buyCcy, objAdjustment, updateAdjustment, currenciesList, adjustmentTypeList, vaultList, referenceTypeList, changeScreen, updateBuyCurrencyValue, backToSearchScreen}) {

    const [buyCurrency, setBuyCurrency] = useState(localStorage.getItem('BNBase Currency'));
    const [buyScale, setBuyScale] = useState(2);
    const [referenceDate, setReferenceDate] = useState(new Date());
    const [accountingDate, setAccountingDate] = useState(new Date());
    const [referenceType, setReferenceType] = useState('');
    const [referenceID, setReferenceID] = useState('');
    const [totalBuyAmount, setTotalBuyAmount] = useState(0);
    const [vaultID, setVaultID] = useState(-1);
    const [vaultName, setVaultName] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showVoidConfirmation, setShowVoidConfirmation] = useState(false);
    const [currencyPairs, setCurrencyPairs] = useState([]);
    const [adjustmentRows, setAdjustmentRows] = useState([{
        key:1,
        CurrencyID: '',
        CurrencyName:'',
        CurrencyScale: 2,
        AdjustmentType: '',
        Amount: 0,
        CostRate: 0,
        BuyAmount: 0,
        Comments:'',
        RatePrecision:8,
        RateTerms:'D',
        validations:{
            CurrencyID: true,
            AdjustmentType: true,
            Amount: true,
            CostRate: true,
            BuyAmount: true
        }        
    }]);
   
    const [validationsHeader, setValidationsHeader] = useState(
      {
          VaultID: true,
          ReferenceDate: true,
          ReferenceType: true,
          CurrencyID: true
        }
      )

    const getToday = () =>{
      const startDate = new Date();
      startDate.setHours(0, 0, 0, 0);
      let validToday = false;

      while(!validToday)
      {       
        if(startDate.getDay() !== 0 && startDate.getDay()!== 6)
        {
          validToday = true;
        }
        else{
            startDate.setDate(startDate.getDate() - 1);
        }
     }
      return new Date(startDate);
    }

     useEffect(()=>{
        
        const today = getToday();      
        setReferenceDate(today);
      },[])

      useEffect(()=>{  
        if(buyCcy)
        {
            const pairs = JSON.parse(localStorage.getItem('CurrencyPairs'));
            if(pairs && pairs.length > 0)
            {
                const basePairs = pairs.filter(ccy => ccy.CurrencyCode === buyCcy);
                setCurrencyPairs(basePairs);
            }
            setBuyCurrency(buyCcy);
        }
      },[buyCcy])
  
    useEffect(()=> {
      if(objAdjustment && objAdjustment.AdjustmentRows && objAdjustment.AdjustmentRows.length>0)
      {
        setAdjustmentRows(objAdjustment.AdjustmentRows);     
      }
      if(objAdjustment.CurrencyID)
      {
        setBuyCurrency(objAdjustment.CurrencyID);
      }

      if(objAdjustment.ReferenceDate && objAdjustment.ReferenceDate !== '')
      {
        setReferenceDate(objAdjustment.ReferenceDate);
      }
      
      if(objAdjustment.AccountingDate && objAdjustment.AccountingDate !== '')
      {
        setAccountingDate(objAdjustment.AccountingDate);
      }

      if(objAdjustment.VaultID && (objAdjustment.VaultID !== -1 || objAdjustment.VaultID !== '-1'))      {
        setVaultID(objAdjustment.VaultID);
        setVaultName(objAdjustment.VaultName);
      }

      if(objAdjustment.ReferenceType){
        
          setReferenceType(objAdjustment.ReferenceType);   
      }

        if(objAdjustment.ReferenceID > 0)
        {   
          setReferenceID(objAdjustment.ReferenceID);
        }         
      
    },[objAdjustment])

    const getRows=()=>{
        const rows = [];
        if(adjustmentRows)
        {
            adjustmentRows.forEach((o, index) =>{
                            rows.push(<AdjustmentRow rowObject={o} rowID={o.key} currenciesList={currenciesList} currencyPairs={currencyPairs}
                                buyScale={buyScale} onDeleteRow={onDeleteRow} onUpdateFieldRow={onUpdateFieldRow} validations={o.validations} onUpdateRowAmounts={onUpdateRowAmounts}
                                autoFocus={(adjustmentRows.length> 1 && index === adjustmentRows.length -1)} adjustmentTypeList={adjustmentTypeList} />)
                        })
        }
        return rows;
    }

    const currencyAlreadyExists = (currencyID, key) => {
      const existCCy = adjustmentRows.find(o => o.CurrencyID === currencyID && o.key !== key);
      if(existCCy)
        return false
      return true;
    }

    const rowIsValid = (lastAdjustment) =>{
      
      const prev = lastAdjustment.validations;

      const validations = {
        ...prev,
        Amount: lastAdjustment.Amount > 0,
        BuyAmount: lastAdjustment.BuyAmount > 0,
        CurrencyID: !!lastAdjustment.CurrencyID, //&& currencyAlreadyExists(lastAdjustment.CurrencyID, lastAdjustment.key),
        AdjustmentType: lastAdjustment.AdjustmentType !== '' && !lastAdjustment.AdjustmentType.toLowerCase().includes('select'),
        CostRate: lastAdjustment.CostRate > 0
      };

      return validations;
    }

    const onAddClick =() =>{
        const adjustment = {};
        adjustment.key = adjustmentRows.length > 0 ? (adjustmentRows[adjustmentRows.length - 1].key + 1) : 1;
        adjustment.BuyAmount = 0;
        adjustment.validations={
            CurrencyID: true,
            AdjustmentType: true,
            Amount: true,
            CostRate: true,
            BuyAmount: true
        }        
        const adjustments = [...adjustmentRows];
        if(adjustments.length > 0)
        {
          const lastAdjustment = adjustments[adjustments.length - 1];
          const validations = rowIsValid(lastAdjustment)
          adjustments[adjustments.length - 1] = {...lastAdjustment,validations};
            
          if(Object.values(validations).every(Boolean))
          {
            adjustment.validations = validations;
            adjustments.push(adjustment);
          }   
          else
          {
            setAlertTitle('Error');
            setAlertMessage('You missed some fields.');       
            setShowAlert(true);            
          }               
        }
        else
        {
          adjustments.push(adjustment);
        }
        setAdjustmentRows(adjustments);
    }

    const onDeleteRow = (key) => {
        let rows = [...adjustmentRows];    
        rows = rows.filter((d) => d.key !== key);
        setAdjustmentRows(rows);
    };
    
    const onUpdateFieldRow = (key, Field, value) =>{
        setAdjustmentRows(prev => {
            const rows = [...prev];
            const index = rows.findIndex((r) => r.key === key );
            if(index > -1)
            {
                rows[index] = { ...rows[index], [Field]: value };
            }
            return rows;
        });
    }

    const onUpdateRowAmounts = (key, amount, costRate, buyAmount, ratePrecision, rateTerms) =>{
        setAdjustmentRows(prev => {
            const rows = [...prev];
            const index = rows.findIndex((r) => r.key === key );
            if(index > -1)
            {
                rows[index] = { ...rows[index], Amount: amount, CostRate: costRate, BuyAmount:buyAmount, RatePrecision: ratePrecision, RateTerms: rateTerms };
            }
            return rows;
        });
    }

  const updateTotalValues = useCallback((totalBuyAmount) =>{
    setTotalBuyAmount(totalBuyAmount);
  }, []);

  const validHeader= ()=>{
     const prev = validationsHeader;
     const today = new Date().setHours(0, 0,0,0);
    const selectedDateTime = new Date(referenceDate).setHours(0, 0,0,0);

    const validations = {
        ...prev,
        ReferenceDate: selectedDateTime <= today,
        ReferenceType: (referenceType !== null && referenceType !== undefined && referenceType !== ''),
        CurrencyID: (buyCurrency !== null && buyCurrency !== undefined && buyCurrency !== ''),
        VaultID: (vaultID !== null && vaultID !== undefined && vaultID >0)
      };

    setValidationsHeader(validations);

    return Object.values(validations).every(Boolean)
  }

  const onNextClick = async() =>{

    const adjustments = [...adjustmentRows];
    if(adjustments.length > 0)
    {

    const adjustmentRowsValidated = adjustmentRows.map(o => ({
        ...o,
        validations: rowIsValid(o)
      }));
      setAdjustmentRows(adjustmentRowsValidated);

      const allValid = adjustmentRowsValidated.every(o =>
        Object.values(o.validations).every(Boolean)
      );

      const headerIsValid = validHeader();
        
      if(allValid && headerIsValid)
      {
        objAdjustment.ReferenceDate = referenceDate;
        objAdjustment.AccountingDate = accountingDate;
        objAdjustment.ReferenceType = referenceType;
        objAdjustment.ReferenceID = referenceID;
        objAdjustment.VaultID = vaultID;
        objAdjustment.AdjustmentRows = adjustmentRowsValidated;
        objAdjustment.TotalAdjusted = totalBuyAmount;
        objAdjustment.CurrencyID = buyCurrency;
        objAdjustment.VaultName = vaultName;

        updateAdjustment(objAdjustment);
        changeScreen();
      }   
      else
      {        
        setAlertTitle('Error');
        setAlertMessage('You missed some fields.');       
        setShowAlert(true);
      }               
    }

  }

  const updateField = (field, value) =>{
    switch(field){
        case "VaultID": setVaultID(Number(value)); break;
        case "VaultName": setVaultName(value); break;
        case "ReferenceType": setReferenceType(value); break;
        case "ReferenceDate": setReferenceDate(value); break;
        case "AccountingDate": setAccountingDate(value); break;
        case "ReferenceID": setReferenceID(value); break;
        default: break;
    }
  }

  const updateBuyCurrency = (currency) =>{
    if(currency.value !== '')
    {
      setBuyCurrency(currency.value);
      setBuyScale(currency.NumberOfDecimals);

      updateBuyCurrencyValue(currency.value);
    }
  }

  const getHeaders = () =>{
     return(
            <tr>
                <th key="1" style={{width:'20%'}}>Currency</th>
                <th key="2" style={{width:'10%'}}>Profit/Loss</th>  
                <th key="3" style={{width:'15%'}}>Amount</th>        
                <th key="4" style={{width:'15%'}}>Rate</th>
                <th key="5" style={{width:'15%'}}>{`${buyCurrency} Value`}</th>
                <th key="6">Comments</th>
                <th key="7" style={{width:'5%'}}></th>
            </tr>
        );
  }

  const closeAlert = () => {
        setShowAlert(false);
        setAlertTitle('');
        setAlertMessage('');
    };

  const openAlert = (title, message) => {
        setShowAlert(true);
        setAlertTitle(title);
        setAlertMessage(message);
    };


  const onTab = (e) => {

    if (e.key === 'Tab') {
      e.preventDefault();
      onAddClick();
    }
  }  

  const closeVoidConfirmation = () =>{
    setShowVoidConfirmation(false);
  }

  const onVoidClick = ()=>{
    setShowVoidConfirmation(true);
  }

    const yesVoidConfirmation = async() =>{
      setShowVoidConfirmation(false);
      setLoading(true);
      const responseSave = await voidAdjustment(objAdjustment.AdjustmentID);
      setLoading(false);    
      const message = [];
      message.push(responseSave.Message);    
      if(responseSave.Success)
      {
         if(backToSearchScreen)
         {
          backToSearchScreen();
         }
      }
    
      setAlertTitle(responseSave.Title);
      setAlertMessage(message);
      setShowAlert(true);
      
    }

  return (
    <div>

        <div>
                <AdjustmentHeader validations={validationsHeader} referenceTypeSelected={referenceType} date={referenceDate} date2={accountingDate}
                  updateField = {updateField} vaultList={vaultList} referenceTypeList={referenceTypeList} referenceIDSelected={referenceID}
                  vaultSelected={vaultID} currenciesList={currenciesList} updateBuyCurrency={updateBuyCurrency}
                  buyCurrencySelected={buyCurrency} />
        
            <table className="uk-table uk-table-hover uk-table-divider badjustment-table">
                <thead>
                        {getHeaders()}
                </thead>
                <tbody>
                        {getRows()}
                </tbody>
            </table>
        
        </div>
        <div  align="right">
            <button id={'btn-adjustment-add'} onKeyDown={onTab} key={'btn-adjustment-add'} className="uk-button uk-button-green" onClick={onAddClick}>
                {'Add'}
            </button>
        </div>
        <Divider />
       <AdjustmentFooter adjustmentRows={adjustmentRows} buyScale={buyScale} updateTotalValues={updateTotalValues}/>
        <Divider />
        <div  align="right">
            {objAdjustment.AdjustmentID && objAdjustment.AdjustmentID !== '' &&
            <button className="uk-button uk-button-green" onClick={onVoidClick}>
                {'Void'}
            </button>}
            <button className="uk-button uk-button-green" onClick={onNextClick}>
                {'Next'}
            </button>
        </div>
        <LoadingBox loading={loading}/>
        <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
        <AlertBox id="void-confirmation"
                                    open={showVoidConfirmation}
                                    title="Confirmation"
                                    message="Are you sure you want to void this adjustment?"
                                    type="Yes/No"
                                    onClose={closeVoidConfirmation}
                                    yesClick={yesVoidConfirmation}
                                    noClick={closeVoidConfirmation}/>
    </div>
  );
};

export default AdjustmentInfo